import React, { useState, useContext } from 'react';
import StepOneComponent from './StepOneComponent';
import './GenerateAccessCode.scss';
import {Stepper}from '@activehub/common-components-spa-resource';
import StepTwoComponent from './StepTwoComponent';
import StepThreeComponent from './StepThreeComponent';
import { SetPopup } from '../../components/set-popup/SetPopup';
import { AppContext } from '../../App';
import { Loader } from "../../components/loader/Loader";
const AccessCodeModal = ({ isOpen, onClose }) => {
  const {
      isbn,
      setIsbn,errorPopup,translate: t,unAuthorizedErrorMessage
  } = useContext(AppContext);

  const [step, setStep] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [currentRequestId, setCurrentRequestId] = useState(null);
  const stepLabels = [
    "Enter ISBN13 or PPID",
    "Add details & generate codes",
    "Export codes"
  ]

  const resetSteps = () => {
    setStep(1);
    setCurrentRequestId(null);
    setIsbn('');
  };
  const onCloseHanlder = () => {
    resetSteps();
    onClose();
  }

const onError = (error) => {  // function to handle error status
    if (error && error.status === 403) {
        errorPopup.setState(unAuthorizedErrorMessage);
    } 
    else if (error && error.status === 404) {
        errorPopup.setState({});
        return;
      }
    else {
        errorPopup.setState({
            isOpen: true,
            heading: t("Oops!! Something went wrong"),
            info: t(`Unable to fetch details.`),
            btnName: t("Okay, Got it"),
            buttonAction: () => errorPopup.setVisibility(false),
            btnStyle: false,
            image: `${process.env.PUBLIC_URL}/images/error-browser.svg`,
            onClosePopup: () => errorPopup.setVisibility(false)
        })
    }
    errorPopup.setVisibility(true);
}


  const dialogMsg=()=>{
    {
     let svgPath = `/images/login-stepper-success.svg`;
      return (
      <div className="access-modal">
        <h2 className="modal-title">Generate access codes</h2>
        <div className="step-header">
          <Stepper steps={stepLabels} active={step} themeClass={"pearsonRoyalBlueV1"} svgPath={svgPath}/>
        </div>
        
        {step === 1 && <StepOneComponent setStep={setStep} isOpen={isOpen} setLoading={setLoading} onError={onError} />}
        {step === 2 && (<StepTwoComponent setStep={setStep} isOpen={isOpen}  onGenerateCodes={() => setStep(3)} setCurrentRequestId={setCurrentRequestId} setLoading={setLoading} onError={onError} />)}
        {step === 3 && <StepThreeComponent setStep={resetSteps} isOpen={isOpen} currentRequestId={currentRequestId} setLoading={setLoading} onError={onError} />}
      </div>
    )
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <SetPopup isOpen={isOpen} closePopup={onCloseHanlder} 
      subInfo={dialogMsg()}
      >
      </SetPopup>
    </>
    
  );
};
 
export default AccessCodeModal;